import {
    Card,
    CardContent,
    Grid,
    Skeleton,
    Stack,
    Typography,
} from '@mui/material';

const ActivityCardSkeleton = () => {
    return (
        <Grid item xs={12} md={6}>
            <Card>
                <CardContent>
                    <Typography variant="h6">
                        <Skeleton variant="text" width={100} />
                    </Typography>
                    <Stack spacing={1.5} sx={{ mt: 2 }}>
                        <Skeleton
                            variant="rectangular"
                            width="90%"
                            height={50}
                        />
                        <Skeleton
                            variant="rectangular"
                            width="90%"
                            height={50}
                        />
                        <Skeleton
                            variant="rectangular"
                            width="90%"
                            height={50}
                        />
                    </Stack>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default ActivityCardSkeleton;
